module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// /mnt/disk/stratbox.dev/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main